import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import IndustrySearch from "../../components/industry-search/component";
import Faq from "../../components/faq/component";
import ErrorHandler from "../../components/error-handler/component";
import {tokenRegister} from "../../services/tokenRegister";
import FaqPrivate from "../../components/faq-private/component";
import Featured from "../../components/featured/component";
import {industriesRegister} from "../../services/industriesRegister";
import {scraperRegister} from "../../services/scraperRegister";
import Typist from "react-typist";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";
import queryString from "query-string";
import Footer from "../../components/footer/component";

class SignupHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            image: null,
            images: [],
            isLoadingButton: false,
            isLoading: true,
            page: 0,
            uploaded_image: null,
            uploaded_image_url: null,
            admin: false,
            error: false,
            private: false,
            industries: []
        };
        this._setloader = this._setloader.bind(this);
    };

    componentWillMount() {

        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
        industriesRegister.remove();
        scraperRegister.remove();
        quotesRegister.setView(null);

        videoRegister.remove();
        carouselRegister.remove();

        window.scrollTo(0, 0);
        this._updateUser();
        this._updateData();
        this._checkPrivate();
        this._selectIndustry = this._selectIndustry.bind(this);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/');
            ReactGA4.send({ hitType: "pageview", page: "/" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({admin: user.reseller, inhouse: user.inhouse});
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _updateData(updated_industry, industry) {
        var parsed = {};
        try {
            parsed = queryString.parse(window.location.search);
        }catch (e) {}
        if(parsed.industry){
            this._selectIndustry(JSON.parse(parsed.industry));
        }else{
            try {
                this._updateIndustries(salesChannelRegister.get('market'), langRegister.lang(), true, updated_industry);
            } catch (error) {
                this.setState({
                    error: true
                });
            }
        }
    }
    _updateIndustries(market, lang, update_images, updated_industry) {
        try {
            this.setState({isLoading: true});
            if(industriesRegister.get()){
                let data = industriesRegister.get();
                for (let i = 0; i < data.length; i++) {
                    try {
                        if (this.state.industry.id === data[i].id) {
                            this.setState({
                                industry: data[i]
                            }, () => {
                                cartRegister.setIndustry(this.state.industry);
                            });
                            break;
                        }
                    } catch (e) {
                        break;
                    }
                }
                this.setState({isLoading: false, industries: data});
            }else{
                dataRegister.industries(market, lang).then((data) => {
                    if (!data.errors) {
                        industriesRegister.set(data);
                        for (let i = 0; i < data.length; i++) {
                            try {
                                if (this.state.industry.id === data[i].id) {
                                    this.setState({
                                        industry: data[i]
                                    }, () => {
                                        cartRegister.setIndustry(this.state.industry);
                                    });
                                    break;
                                }
                            } catch (e) {
                                break;
                            }
                        }
                        this.setState({isLoading: false, industries: data});
                    }
                }, (error) => {
                    if(error.status === 401){
                        tokenRegister.remove();
                        userRegister.remove();
                        window.location.reload();
                    }else{
                        this.setState({
                            error: true
                        });
                    }
                });
            }
        } catch (error) {
            this.setState({
                error: true,
                isLoading: false
            });
        }
    }

    _checkPrivate(){
        if(salesChannelRegister.get("private")){
            this.setState({private: salesChannelRegister.get("private")});
        }
    }

    _next() {
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/crossroad");
    }

    _setloader(value){
        this.setState({isLoading: value, scraper: value});
    }

    _selectIndustry(value) {
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
        cartRegister.setIndustry(value);
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/crossroad");
    }


    _renderText(item) {
        return langRegister.get("signup-image", item);
    }

    _renderSalesChannelText(item, baseKey) {
        let lang = langRegister.lang();
        let registerKey = baseKey + "_" + lang;
        let dynamicValue = salesChannelRegister.get(registerKey);

        if (dynamicValue && dynamicValue !== "") {
            return dynamicValue;
        }

        return this._renderText(item);
    }

    _renderSalesChannelImage(baseKey, fallback) {
        let lang = langRegister.lang();
        let registerKey = baseKey + "_" + lang;
        let dynamicValue = salesChannelRegister.get(registerKey);

        if (dynamicValue && dynamicValue !== "") {
            return dynamicValue;
        }

        return fallback;
    }

    renders = {
        text: (item) => {
            return langRegister.get("signup-image", item);
        }
    };

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>
                {
                    this.state.modal &&
                    <div className={Styles.overlay}>
                        <div className={Styles.overlayModal}>
                            <div className={Styles.overlayModalInner}>
                                <img onClick={() => this.setState({modal: false, industry: false})}
                                     className={Styles.overlayCloseButton}
                                     src={require("../../assets/images/close_icon.svg")}/>
                                <div>
                                    <div className={Styles.overlayModalTitle}>
                                        {this._renderText("item_9")}
                                    </div>
                                    <div className={Styles.overlayModalText}>
                                        <span className={Styles.overlayModalTextBold}>{this._renderText("item_8")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.overlayModalButtons}>
                                <div className={Styles.overlayModalButtonsItem}>
                                    <div onClick={() => this.setState({modal: false, industry: false})}
                                         className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                        ok
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        {
                            !this.state.error &&
                            <div className={Styles.sectionOneRight}>
                                <div className={Styles.sectionOneRightTitle}>
                                    <div className={Styles.sectionOneRightBold}>
                                        {this._renderSalesChannelText("item_10", "signup_home_item_10")}&nbsp;
                                    </div>
                                    <span>{this._renderSalesChannelText("item_12", "signup_home_item_12")}&nbsp;</span>
                                    <span>{this._renderSalesChannelText("item_13", "signup_home_item_13")}</span>
                                    <div className={Styles.sectionOneRightTitleIcons}>
                                        <div className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 0,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxGoogle}
                                                 src={require("../../assets/images/google_logo_icon.svg")}/>
                                        </div>
                                        <div className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 1,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxFb}
                                                 src={require("../../assets/images/facebook_logo_icon.svg")}/>
                                        </div>
                                        <div className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 2,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxBing}
                                                 src={require("../../assets/images/bing_logo_icon.svg")}/>
                                        </div>
                                        <div className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 3,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxInstagram}
                                                 src={require("../../assets/images/instagram_logo_icon.svg")}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.subtitleContainer}>
                                <IndustrySearch setloader={this._setloader} history={this.props.history} selectIndustry={this._selectIndustry} industry={this.state.industry}/>
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.sectionOneRightSubtitle}>
                                <span className={Styles.sectionOneRightSubtitleText}>
                                    {this._renderSalesChannelText("item_14", "signup_home_item_14")}&nbsp;
                                </span>
                                <span className={Styles.sectionOneRightSubtitleTextBold}>
                                    {this._renderSalesChannelText("item_15", "signup_home_item_15")}
                                </span>
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.sectionOneRightTitleIconsMobile}>
                                <div className={
                                    cx(Styles.sectionOneRightTitleIconsBox,
                                        {
                                            [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 0,
                                        })
                                }>
                                    <img className={Styles.sectionOneRightTitleIconsBoxGoogle}
                                         src={require("../../assets/images/google_logo_icon.svg")}/>
                                </div>
                                <div className={
                                    cx(Styles.sectionOneRightTitleIconsBox,
                                        {
                                            [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 1,
                                        })
                                }>
                                    <img className={Styles.sectionOneRightTitleIconsBoxFb}
                                         src={require("../../assets/images/facebook_logo_icon.svg")}/>
                                </div>
                                <div className={
                                    cx(Styles.sectionOneRightTitleIconsBox,
                                        {
                                            [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 2,
                                        })
                                }>
                                    <img className={Styles.sectionOneRightTitleIconsBoxBing}
                                         src={require("../../assets/images/bing_logo_icon.svg")}/>
                                </div>
                                <div className={
                                    cx(Styles.sectionOneRightTitleIconsBox,
                                        {
                                            [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 3,
                                        })
                                }>
                                    <img className={Styles.sectionOneRightTitleIconsBoxInstagram}
                                         src={require("../../assets/images/instagram_logo_icon.svg")}/>
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                    !this.state.error && !this.state.isLoading &&
                    <div className={Styles.shadowContainer}>
                        <img className={Styles.sectionThreeShadowBottom}
                             src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                        <img className={Styles.sectionThreeShadowBottomMobile}
                             src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                    </div>
                }
                {
                    !this.state.error && !this.state.isLoading && this.state.private &&
                    <div className={Styles.informationContainerPrivate}>
                        <div className={Styles.informationContainerPrivateTitle}>
                            {this._renderText("item_31")}
                        </div>
                        <div className={Styles.informationContainerPrivateFaq}>
                            <FaqPrivate/>
                        </div>
                    </div>
                }
                {
                    !this.state.error && !this.state.isLoading && !this.state.private &&
                    <div className={Styles.informationContainer}>
                        <div className={Styles.informationContainerTitle}>
                            <span className={Styles.informationContainerTitleBlack}>{this._renderSalesChannelText("item_16", "signup_home_item_16")}&nbsp;
                                <div
                                    className={Styles.informationContainerTitleBlackUnderline}/></span>{this._renderSalesChannelText("item_17", "signup_home_item_17")}
                        </div>
                        <div className={Styles.informationContainerSubTitle}>
                            {this._renderSalesChannelText("item_18", "signup_home_item_18")}
                        </div>
                        {
                            <img
                                className={cx(Styles.missionImageMobile, Styles.missionImageMobileLast, Styles.airplane)}
                                src={require("../../assets/images/AB_illustration_flight.png")}/>
                        }
                        {
                            <img
                                className={cx(Styles.missionImageDesktop, Styles.missionImageMobileLast)}
                                src={this._renderSalesChannelImage(
                                    "signup_home_mission_desktop",
                                    langRegister.lang() === "sv"
                                        ? require("../../assets/images/Mission_SV.png")
                                        : require("../../assets/images/Mission_EN.png")
                                )}
                            />
                        }
                        {
                            <img
                                className={cx(Styles.missionImageMobile, Styles.missionImageMobileFirst)}
                                src={this._renderSalesChannelImage(
                                    "signup_home_mission_mobile_1",
                                    langRegister.lang() === "sv"
                                        ? require("../../assets/images/Mission_mobile1_SV.png")
                                        : require("../../assets/images/Mission_mobile1_EN.png")
                                )}
                            />
                        }
                        {
                            <img
                                className={cx(Styles.missionImageMobile, Styles.missionImageMobileLast)}
                                src={this._renderSalesChannelImage(
                                    "signup_home_mission_mobile_2",
                                    langRegister.lang() === "sv"
                                        ? require("../../assets/images/Mission_mobile2_SV.png")
                                        : require("../../assets/images/Mission_mobile2_EN.png")
                                )}
                            />
                        }
                    </div>
                }
                {
                    !this.state.error && !this.state.isLoading && !this.state.private &&
                    <Featured/>
                }
                {
                    !this.state.error && !this.state.isLoading && !this.state.private &&
                    <div className={Styles.informationContainer}>
                        <div className={Styles.informationContainerTitle}>
                            <span
                                className={Styles.informationContainerTitleBlack}>{this._renderText("item_19")}<br/></span>{this._renderText("item_20")}&nbsp;
                            <span className={Styles.informationContainerTitleRed}>{this._renderText("item_21")}</span>
                        </div>
                        <div className={Styles.informationContainerSubTitle}>
                            <span
                                className={Styles.informationContainerSubTitleBold}>{this._renderText("item_22")}&nbsp;</span>{this._renderText("item_23")}
                        </div>
                        {
                            <img className={cx(Styles.missionImageMobile, Styles.missionImageMobileLast, Styles.heart)}
                                 src={require("../../assets/images/AB_Illustration_Hearts.png")}/>
                        }
                        <div className={Styles.informationContainerFaq}>
                            <Faq/>
                            <img className={cx(Styles.missionImageDesktopHearts)}
                                 src={require("../../assets/images/AB_Illustration_Hearts.png")}/>
                        </div>
                    </div>
                }
                {
                    !this.state.error && !this.state.isLoading && !this.state.private &&
                    <div className={Styles.sectionSevenTeen}>
                        <img className={Styles.sectionThreeShadowTop}
                             src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                        <img className={Styles.sectionThreeShadowTopMobile}
                             src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                        <div className={Styles.sectionSevenContainer}>
                            <div className={Styles.sectionSevenContainerText}>
                                {this._renderText("item_24")}
                                <div
                                    className={Styles.sectionSevenContainerTextSecond}>{this._renderText("item_25")}</div>
                            </div>
                            <a className={Styles.link} target={"_blank"}
                               href={"https://help."+dataRegister.getDomain()+"/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name')}>
                                <div className={Styles.sectionSevenContainerButton}>
                                    {this._renderText("item_26")}
                                </div>
                            </a>
                        </div>
                        <img className={Styles.sectionThreeShadowBottom}
                             src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                        <img className={Styles.sectionThreeShadowBottomMobile}
                             src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        {
                            this.state.scraper &&
                            <div className={Styles.loaderText}>
                                <span className={Styles.loaderTextBold}>{this.renders.text("item_32")}</span>&nbsp;
                                <Typist stdTypingDelay={0} cursor={{show: false}}>
                                    {this.renders.text("item_33")}
                                    <Typist.Backspace count={this.renders.text("item_33").length} delay={5000}/>
                                    {this.renders.text("item_34")}
                                    <Typist.Backspace count={this.renders.text("item_34").length} delay={5000}/>
                                    {this.renders.text("item_35")}
                                    <Typist.Backspace count={this.renders.text("item_35").length} delay={5000}/>
                                    {this.renders.text("item_36")}
                                </Typist>
                            </div>
                        }
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {

                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <Footer/>
                }
            </div>
        );
    }
}

export default SignupHome;


// WEBPACK FOOTER //
// ./src/pages/signup-home/component.js